import { IFinanceCalculatorState } from "../../../../models/finance-calculator.model";
import { formatCurrency, formatNumber } from "../../../shared/utils";
import { getProductFromKey } from "../FinanceCalculatorResultsTable/FinanceCalculatorResultsTable";

const FinanceCalculatorResultSummary = ({ state }: { state: IFinanceCalculatorState }) => {
    const getCaveatText = () => {
        return "This quote is an example only. The exact figures and rate will be based on your circumstances.";
    }
   
    const getCreditRatingText = () => {
        // return "I consider my credit rating to be " + state.formdata.creditRating + ".";
        return getCaveatText();
    }
    
    const getLoanText = () => {
        let r = "";
        let res = undefined;
        if (state.resultsdata) {
            res = state.resultsdata[state.selectedIndex];
            if (res && res.Quote) {
                const product = getProductFromKey(res.Key);

                r = r + "Please contact me regarding your " + res.Key;
                r = r + " quote of " + (product === "PCP" ? (res.Quote.Term - 1) : (res.Quote.Term)) + " payments of " + formatCurrency(res.Quote.RegularPayment);
                if (product === "PCP") {
                    r = r + ", with a final rental of " + formatCurrency(res.Quote.Residual);
                }
                r = r + " (" + res.Quote.Apr + "% APR).";
            }
        }
        return r;
    };

    const getVehicleText = () => {
        let r = "";
        let res = undefined;
        if (state.resultsdata) {
            res = state.resultsdata[state.selectedIndex];
            if (res && res.Quote) {
                if (!state.formdata.knownRegNo && state.formdata.identity) {
                    r = r + "Vehicle: " + state.formdata.identity.vehicleDesc;
                } else {
                    r = r + "Vehicle: " + state.formdata.regNo.toLocaleUpperCase();
                }
                r = r + ", Current mileage: " + formatNumber(state.formdata.currentMileage);
                const product = getProductFromKey(res.Key);
                if (product === "PCP") {
                    r = r + ", Anticipated annual mileage: " + formatNumber(state.formdata.annualMileage);
                }
                r = r + ".";
            }
        }
        return r;
    };

    return (
     <>
        { false && (
            <div>{getLoanText()}</div>
        )}
        { state.formdata.vehicleBased && (state.formdata.regNo || state.formdata.identity) &&
            (<div>{getVehicleText()}</div>)
        }
        <div>{getCreditRatingText()}</div>
        <br/>
     </>
     ); 
   };
   
export default FinanceCalculatorResultSummary;
   